import { render, staticRenderFns } from "./StaffTable.vue?vue&type=template&id=4eb55296&scoped=true&"
import script from "./StaffTable.vue?vue&type=script&lang=js&"
export * from "./StaffTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eb55296",
  null
  
)

export default component.exports